import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import debounce from 'lodash/debounce';

require('intersection-observer');

export default (el, props) => {
    const dom = $(el);
    const holder = dom.find('[data-holder]');
    const item = dom.find('[data-item]');
    const marquee = dom.find('[data-marquee]');

    let timeline = null;
    let viewportWidth = 0;
    let debouncedResize;
    let isWatching = false;
    let isSetup = false;
    let observer;

    const resetHolders = () => {
        dom.find('[data-holder]').each(h => {
            TweenMax.set(h, { clearProps: 'all' });
        });
    };

    const killTweens = () => {
        if (timeline !== null) {
            timeline.kill();
            timeline = null;
        }
    };

    const setupTween = () => {
        const holders = dom.find('[data-holder]');
        holders.each((h, i) => {
            $(h).addClass('pos-a');
            $(h).css('left', `${$(h).width() * i}px`);
        });

        timeline = new TimelineMax({ paused: true })
            .to(holders.nodes, 18, { xPercent: -100, ease: Linear.easeNone }, 0)
            .repeat(-1);

        if (props.type === 'logo') {
            timeline.seek(15);
            TweenMax.to(marquee.get(0), 0.75, { opacity: 1 });
        }
    };

    const play = () => {
        window.timefoo = timeline;
        isWatching = true;
        TweenMax.killTweensOf(timeline);
        timeline.timeScale(props.type === 'text' ? 1 : 2);
        timeline.play();
        dom.find('[data-holder]').addClass('u-wc-t');
    };

    const pause = () => {
        const holders = dom.find('[data-holder]');
        isWatching = false;
        TweenMax.to(timeline, 0.5, { timeScale: 0.01, onComplete: timeline.pause });
        holders.removeClass('u-wc-t');
    };

    const inviewSetup = () => {
        if ($('html').hasClass('is-live-preview')) {
            return;
        }

        observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const { isIntersecting } = entry;

                if (isIntersecting && !isWatching) {
                    play();
                } else if (!isIntersecting && isWatching) {
                    pause();
                }
            });
        }, {
            root: null,
            threshold: 0
        });
        observer.observe(el);
    };

    const fillText = () => {
        marquee.empty().append(holder);
        holder.empty().append(item);
        if (props.type === 'text') {
            holder.append('<span>&nbsp;•&nbsp;</span>');
        }
        const textWidth = item.width();
        const count = Math.ceil(viewportWidth / textWidth) - 1;

        for (let i = 0; i < count; i += 1) {
            holder.append(item.clone());
            if (props.type === 'text') {
                holder.append('<span>&nbsp;•&nbsp;</span>');
            }
        }

        marquee.append(holder.clone());
    };

    const fillLogo = () => {
        fillText();
    };

    const setHeight = () => {
        const height = item.height();
        dom.css('height', `${height}px`);
    };

    const updateMarquee = () => {
        killTweens();
        resetHolders();
        setHeight();
        if (props.type === 'logo') {
            fillLogo();
        } else {
            fillText();
        }
        const holderWidth = holder.width();
        const holders = dom.find('[data-holder]');
        marquee.css('width', `${holderWidth * holders.length}px`);
        setupTween();

        if (Viewport.visible(el)) {
            play();
        }
    };

    const onResize = () => {
        console.log('onResize');

        if (isSetup && viewportWidth !== Viewport.width) {
            console.log('onResize: CHANGED');
            viewportWidth = Viewport.width;
            updateMarquee();
        }
    };

    const teardown = () => {
        isSetup = false;
        observer.unobserve(el);
        timeline.stop();
        debouncedResize = null;
        Viewport.off('resize', debouncedResize);
        TweenMax.set([marquee.get(0), el], { clearProps: 'all' });
        marquee.removeClass('pos-a');
        holder.removeClass('pos-a');
        killTweens();
        resetHolders();
        marquee.empty().append(holder);
        holder.empty().append(item);
    };

    const setup = () => {
        isSetup = true;
        viewportWidth = Viewport.width;
        marquee.addClass('pos-a');
        updateMarquee();
        debouncedResize = debounce(onResize, 500);
        Viewport.on('resize', debouncedResize);
        inviewSetup();
        if (props.type === 'text') {
            dom.on('mouseenter', pause);
            dom.on('mouseleave', play);
        }
    };

    const onBreakpoint = data => {
        console.log(data.detail.old.size < 750, data.detail.current.size);
        if (isSetup && data.detail.old.size < 750 && data.detail.current.size >= 750) {
            console.log('stop');
            teardown();
        } else if (!isSetup && data.detail.old.size >= 750 && data.detail.current.size < 750) {
            console.log('start');
            setup();
        }
    };

    const init = () => {
        if (props.type === 'logo') {
            Viewport.on('breakpoint', onBreakpoint);
            if (Viewport.width < 750) {
                setup();
            }
        } else {
            setTimeout(setup, 500);
        }
    };

    const destroy = () => {
        if (props.type === 'text') {
            dom.off('mouseenter', pause);
            dom.off('mouseleave', play);
        }
        if (props.type === 'logo') {
            Viewport.off('breakpoint', onBreakpoint);
        }
        Viewport.off('resize', debouncedResize);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Marquee.js